export default __webpack_public_path__ + "static/media/black_close.17a94979.svg";